import React from "react";
import { useState, useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import "./style.scss"
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { Button } from "@mui/material";
import { getBookBySearch, getCategories, getTargets } from "services/user/bookService";
import { BsPencil } from "react-icons/bs";
import { RiDeleteBin6Line } from "react-icons/ri";
import { Formatter } from "utils/formatter";
import Pagination from '@mui/material/Pagination';
import { Link } from "react-router-dom";
import { findCategoryIdBySlug } from "utils/createSlug";
import { getAllHiddenBooks, getBookByCategoryID, getBooksBySearch, getHiddenBooksByCategory, unhideBook } from "services/admin/bookService";
import { generateSlug } from "utils/createSlug";
// import { getAllBooks } from "services/user/bookService";
import { getAllBooks } from "services/admin/bookService";
import { MyContext } from "../theme/adminLayout";
import { useContext } from "react";
import Swal from "sweetalert2";
import { deleteBook } from "services/admin/bookService";
import { PacmanLoader } from "react-spinners";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { introspective } from "services/tokenService";

const BookList = () => {
    const context = useContext(MyContext);
    const { slug } = useParams(); // Lấy slug từ URL

    const [isLoading, setIsLoading] = useState(false);

    const [isHidden, setIsHidden] = useState(false)

    const [refreshFetchBook, setRefreshFetchBook] = useState(false);
    
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const [page, setPage] = useState(Number(searchParams.get('page') || 1));
    // const page1 = searchParams.get('page') || 1;
    const [searchText, setSearchText] = useState(searchParams.get("q") || '');
    const query = searchParams.get("q")

    const [books, setBooks] = useState([]);
    // const [page, setPage] = useState(+page1);
    const [totalPage, setTotalPage] = useState(1);
    const navigate = useNavigate();
    const token = localStorage.getItem("token")

    const [categoryVal, setCategoryVal] = useState(0); // category của select
    
    const [categories, setCategories] = useState([]);
    const [bookPermission, setBookPermission] = useState(""); // lưu xem có quyền qly sách không

    useEffect(() => {
        const fetchPermissions = async () => {
            try {
                const response = await introspective(token);
                if (response.data) {
                    setBookPermission(response.data.permissions.some(permission => permission.id === 2)); // id 2 là sách
                }
            } 
            catch (error) {
                console.log("introspective failed:", error);
            } 
        };

        fetchPermissions();

    }, [token]);
    console.log(bookPermission)
    // categories
    useEffect(() => {
        const fetchCategories = async() => {
            try {
                const response = await getCategories();
                setCategories(response.data);
            } catch (error) {
                console.error("Error fetching categories:", error);
            }
        };

        fetchCategories();
    },[])

    // getBookByCategoryId
    useEffect(() => {
        const categoryId = findCategoryIdBySlug(categories, slug);
        if (categoryId) {
            setCategoryVal(categoryId);
            const fetchBookByCategory = async () => {
                setIsLoading(true)
                try {
                    if (!isHidden) {
                        const response = await getBookByCategoryID(token, categoryId, page - 1);
                        if (response && response.data) {
                            setBooks(response.data.content);
                            setTotalPage(response.data.page.totalPages);
                        }
                    }
                    else {
                        const response = await getHiddenBooksByCategory(token, categoryId, page - 1);
                        if (response && response.data) {
                            setBooks(response.data.content);
                            setTotalPage(response.data.page.totalPages);
                        }
                    }
                } 
                catch (error) {
                    console.error("fetchBookByCategory", error);
                } 
                finally {
                    setIsLoading(false);
                }
            };
            fetchBookByCategory();
        }
        // else if (slug === "alls") {
        //     setCategoryVal(0); // allBoooks
        // }
        
        window.scrollTo(0, 0);
    }, [slug, page, categories, token, isHidden, refreshFetchBook]);
    
    console.log(categoryVal)

     // getAllBooks
    useEffect(() => {
        // if (categoryVal === 0) {
        if (slug === "all") {
          const fetchAllBooks = async () => {
                setIsLoading(true)
                try {
                    if (!isHidden) {
                        const response = await getAllBooks(token, page - 1);
                        if (response && response.data) {
                            setBooks(response.data.content);
                            setTotalPage(response.data.page.totalPages);
                        }
                    }
                    else {
                        const response = await getAllHiddenBooks(token, page - 1);
                        if (response && response.data) {
                            setBooks(response.data.content);
                            setTotalPage(response.data.page.totalPages);
                        }
                    }
                } 
                catch (error) {
                    console.error("fetchAllBooks", error);
                } 
                finally {
                    setIsLoading(false);
                }
                
            };
            fetchAllBooks();
        }
    }, [categoryVal, page, token, slug, isHidden, refreshFetchBook]);

    useEffect(() => {
        if (slug === "search") {
            console.log('im a super')
            const fetchBooksBySearch = async () => {
                setIsLoading(true)
                try {
                    const response = await getBooksBySearch(token, searchText.trim(), page - 1)
                    if (response && response.data && response.data.content && response.data.page) {
                        setBooks(response.data.content);
                        setTotalPage(response.data.page.totalPages);
                    }
                } 
                catch (error) {
                    console.log("fetchBookBySearch", error)
                }
                finally {
                    setIsLoading(false)
                }
                
            };
            fetchBooksBySearch();
        }
    }, [page, token, slug, query, refreshFetchBook]);

    const handleChangeCate = (event) => {
        setCategoryVal(event.target.value);
    };

    const handleChangePage = (event, value) => {
        // if (categoryVal === 0) {
        if (slug === "all") {
            setPage(value);
            navigate(`/admin/list-book/all?page=${value}`);
        }
        else if (slug === "search") {
            setPage(value);
            navigate(`/admin/list-book/search?q=${searchText.trim()}&page=${value}`);
        }
        else {
            const category = categories.find(category => category.id === categoryVal);
            const slug = generateSlug(category.name);  
            setPage(value);
            navigate(`/admin/list-book/${slug}?page=${value}`);
        }
    };

    const handleCategoryClick = (id) => {
        if (id === 0) {
            setCategoryVal(id);
            navigate(`/admin/list-book/all`);
            setPage(1)
        }
        else {
            const category = categories.find(category => category.id === id);
            const slug = generateSlug(category.name); 
            setCategoryVal(id);
            navigate(`/admin/list-book/${slug}`);
            setPage(1)
        }
    };

    const handleEditClick = (bookID) => {
        // console.log(bookID)
        navigate('/admin/update-book', { state: { bookID } });
    }

    const handleDeleteBook = async (book) => {
        const result = await Swal.fire({
            title: "Bạn chắc chắn muốn xoá?",
            text: `Xác nhận sẽ xoá Sách "${book.title}"!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Xác nhận xoá!",
            cancelButtonText: "Huỷ"
        });
        
        if (result.isConfirmed) {
            setIsLoading(true)
            try {
                const response = await deleteBook(token, book.id);
                if (response.data.message === "Book has been hidden!") {
                    Swal.fire({
                        title: "Xoá thành công!",
                        text: `Sách "${book.title}" đã được xoá.`,
                        icon: "success"
                    }).then(() => {
                        // window.location.reload();
                        setRefreshFetchBook((prev) => !prev);
                    });
                }
                else {
                    Swal.fire({
                        title: "Có lỗi xảy ra!",
                        text: "Xoá sách thất bại. Vui lòng kiểm tra lại thông tin.",
                        icon: "error"
                    });
                }
            } 
            catch (error) {
                console.log("Delete book", error)
                Swal.fire({
                    title: "Có lỗi xảy ra!",
                    text: "Xoá sách thất bại. Vui lòng kiểm tra lại thông tin.",
                    icon: "error"
                });
            }
            finally {
                setIsLoading(false)
            }
            
        }
    }

    const handleUnhideBook = async (book) => {
        const result = await Swal.fire({
            title: "Bạn có muốn hiển thị sách?",
            text: `Xác nhận sẽ hiển thị lại Sách "${book.title}"!`,
            icon: "info",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Xác nhận!",
            cancelButtonText: "Huỷ"
        });
        
        if (result.isConfirmed) {
            setIsLoading(true)
            try {
                const response = await unhideBook(token, book.id);
                console.log(response.data.message)
                if (response.data.message === "Book is on displayed!") {
                    Swal.fire({
                        title: "Thành công!",
                        text: `Sách "${book.title}" đã được hiển thị.`,
                        icon: "success"
                    }).then(() => {
                        // window.location.reload();
                        setRefreshFetchBook((prev) => !prev);
                    });
                }
                else {
                    Swal.fire({
                        title: "Có lỗi xảy ra!",
                        text: "Hiển thị lại sách thất bại. Vui lòng kiểm tra lại thông tin.",
                        icon: "error"
                    });
                }
            } 
            catch (error) {
                console.log("Unhide book", error)
                Swal.fire({
                    title: "Có lỗi xảy ra!",
                    text: "Hiển thị lại sách thất bại. Vui lòng kiểm tra lại thông tin.",
                    icon: "error"
                });
            }
            finally {
                setIsLoading(false)
            }
            
        }
    }

    const handleHidden = () => {
        if (slug === "search") {
            navigate("/admin/list-book/all")
            setSearchText('')
            setIsHidden(!isHidden)
        }
        setIsHidden(!isHidden)
    }

    const handleSearchChange = (e) => {
        const text = e.target.value;
        setSearchText(text);
    };

    // const fetchBookBySearch = async () => {
    //     setIsLoading(true)
    //     try {
    //         const response = await getBookBySearch(searchText, page - 1)
    //         if (response && response.data && response.data.content && response.data.page) {
    //             setBooks(response.data.content);
    //             setTotalPage(response.data.page.totalPages);
    //         }
    //     } 
    //     catch (error) {
    //         console.log("fetchBookBySearch", error)
    //     }
    //     finally {
    //         setIsLoading(false)
    //     }
    // }
  
    const handleKeyDownSearch = (event) => {
        if (event.key === "Enter") {
           navigate(`/admin/list-book/search?q=${searchText.trim()}`)
           setCategoryVal(0)
           setPage(1)
           setIsHidden(false)
        }
    }

    return (
        <div className="BookList">
            <div className="card border-0 p-4 mt-5">
                <div className="headCard d-flex">
                    <h5>Tất cả sản phẩm</h5>
                    <Link to={bookPermission ? "/admin/add-book" : "#"} className="ms-auto">
                        <Button 
                            onClick={(e) => {
                                if (!bookPermission) {
                                    e.preventDefault();
                                    Swal.fire({
                                        icon: 'error',
                                        title: 'Không có quyền',
                                        text: 'Bạn không có quyền thêm mới sách.',
                                    });
                                }
                            }}
                        >
                            Thêm mới sách
                        </Button>
                    </Link>
                </div>
                <hr />

                <div className="row cardFilters">
                    <div className="col-4">
                        <h4>Thể loại</h4>
                        <Select
                            className="custom-select"
                            value={categoryVal}
                            onChange={handleChangeCate}
                            displayEmpty
                            inputProps={{ 'aria-label': 'Without label' }}
                            MenuProps={{
                                disableScrollLock: true,
                                PaperProps: {
                                    style: {
                                        maxHeight: 200, 
                                        overflowY: 'auto',
                                    },
                                },
                            }}
                            sx={{
                                '&.MuiOutlinedInput-root': {
                                    // '& fieldset': {
                                    //     borderColor: 'red',
                                    // },
                                    '&:hover fieldset': {
                                        borderColor: '#9d2ff7',
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: '#9d2ff7',
                                    },
                                },
                            }}
                        >
                            <MenuItem disabled>
                                <em>Thể loại</em>
                            </MenuItem>

                            <MenuItem value={0} onClick={() => handleCategoryClick(0)} >Tất cả sản phẩm</MenuItem>

                            {categories && categories.length > 0 ? (
                                categories.map(category => (
                                    <MenuItem key={category.id} value={category.id} onClick={() => handleCategoryClick(category.id)}>{category.name}</MenuItem>
                                ))
                            ) : (
                                <MenuItem disabled>No categories available</MenuItem>
                            )}
                        </Select>
                    </div>
                    <div className="col-6">
                        <h4>Tìm kiếm</h4>
                        <input 
                            type="text" 
                            value={searchText}
                            placeholder="Search...!!!" 
                            onChange={handleSearchChange} 
                            onKeyDown={handleKeyDownSearch}
                        />
                    </div>

                    <div className="col-2 d-flex flex-column">
                        <h4 className="ms-auto">Ẩn/Hiện sách</h4>
                        <Button onClick={handleHidden} className="ms-auto" color="secondary">{isHidden ? <FaRegEyeSlash/> : <FaRegEye/>}</Button>
                    </div>
                </div>

                <div className="table-responsive mt-3">
                    <table className="table table-bordered v-align">
                        <thead className="thead-dark">
                            <tr>
                                <th>ID</th>
                                <th>SÁCH</th>
                                <th>THỂ LOẠI</th>
                                <th>TÁC GIẢ</th>
                                <th>GIÁ</th>
                                <th>KHO</th>
                                <th>ĐƠN HÀNG</th>
                                <th>ACTION</th>
                            </tr>
                        </thead>

                        <tbody>
                            {books && books.length > 0 ? (
                                books.map((book, index) => (
                                    <tr key={book.id}>
                                        <td>{index+1}</td>
                                        <td>
                                            <div className="d-flex productBox"
                                            style={{ width: context.isToggleSidebar ? '30rem' : '22rem' }}>
                                                <div className="imgWrapper1">
                                                    <div className="img">
                                                        <img className="w-100" src={book.imageLink} alt="" loading="lazy"/>
                                                    </div>
                                                </div>
                                                <h6 style={{textAlign: 'left'}}>{book.title}</h6>
                                            </div>
                                        </td>
                                        <td>{book.category ? book.category : categoryVal}</td>
                                        <td>{book.authorNames && book.authorNames.length > 0 ? book.authorNames.join(", ") : "a"}</td>
                                        <td>
                                            <span className="new text-danger">{Formatter(book.discountedPrice)}</span>
                                            <del className="old">{Formatter(book.originalPrice)}</del>
                                        </td>
                                            {book.availableQuantity ? (
                                                <td>
                                                    {book.availableQuantity}
                                                </td>
                                            ) : (
                                                <td style={{ whiteSpace: "nowrap", padding: '5px'}}>
                                                <span style={{color: 'red', background: 'blue', padding: '5px', borderRadius: '5px', background: 'rgb(255, 214, 214)'}}>Hết hàng</span>
                                            </td>
                                            )}

                                        
                                        <td>{book.soldQuantity}</td>
                                        <td>
                                            <div className="actions d-flex align-items-center">
                                                {!isHidden ? (
                                                    <>
                                                        <Button 
                                                            className="primary" 
                                                            color="primary"
                                                            onClick={() => navigate(`/admin/detail/${book.id}`)}
                                                        >
                                                            <FaRegEye/>
                                                        </Button>
                                                        <Button 
                                                            className="secondary" 
                                                            color="secondary"
                                                            onClick={() => {
                                                                if (!bookPermission) {
                                                                    Swal.fire({
                                                                        icon: 'error',
                                                                        title: 'Không có quyền',
                                                                        text: 'Bạn không có quyền chỉnh sửa sách này.',
                                                                    });
                                                                } 
                                                                else {
                                                                    handleEditClick(book.id);
                                                                }
                                                            }}
                                                        >
                                                            <BsPencil />
                                                        </Button>
                                                        <Button 
                                                            className="error" 
                                                            color="error"
                                                            onClick={() => {
                                                                if (!bookPermission) {
                                                                    Swal.fire({
                                                                        icon: 'error',
                                                                        title: 'Không có quyền',
                                                                        text: 'Bạn không có quyền xoá sách này.',
                                                                    });
                                                                } 
                                                                else {
                                                                    handleDeleteBook(book);
                                                                }
                                                            }}
                                                        > 
                                                            <RiDeleteBin6Line />
                                                        </Button>
                                                    </>
                                                ) : (
                                                    <Button 
                                                        className="secondary" color="secondary"
                                                        onClick={() => {
                                                            if (!bookPermission) {
                                                                Swal.fire({
                                                                    icon: 'error',
                                                                    title: 'Không có quyền',
                                                                    text: 'Bạn không có quyền hiển thị lại sách này.',
                                                                });
                                                            } 
                                                            else {
                                                                handleUnhideBook(book)
                                                            }
                                                        }}
                                                    >
                                                        <FaRegEyeSlash />
                                                    </Button>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr></tr>
                            )}
                        </tbody>
                    </table>

                    <div className="d-flex tableFooter">
                        <Pagination 
                            className="ms-auto" 
                            count={totalPage} 
                            color="secondary"
                            page={page} 
                            onChange={handleChangePage}
                        />
                    </div>
                </div>
            </div>
            
            {isLoading && (
                <div className="modal">
                    <div className="overlay_loading">
                        <div className="modal-content_loading">
                            <div className="d-flex">
                            <PacmanLoader color="#5e2e86"/>
                            </div>
                        </div>
                    </div>
                </div>
            )} 
        </div>
    )
}

export default BookList;